/* eslint-disable complexity */
import React, { useEffect, useRef, useState } from 'react';
import ctl from '@netlify/classnames-template-literals';
import { useLocale } from 'hooks/useLocale';
import SVGIcon from 'components/shared/SVGIcon';
const PasswordIcon = ({ isShowPasswordValue, onClick }) => {
    return (React.createElement(SVGIcon, { iconName: isShowPasswordValue ? 'icon-remove_red_eye' : 'icon-disabled_red_eye', fillColor: "var(--n-600)", onClick: onClick, size: isShowPasswordValue ? 20 : 24, customClass: `absolute ${isShowPasswordValue ? 'right-[14px]' : 'right-[12px]'} ` }));
};
const CalendarIcon = ({ disabled }) => {
    return (React.createElement(SVGIcon, { iconName: "icon-calendar_today", fillColor: disabled ? 'var(--n-600)' : 'var(--base-600)', size: 24, customClass: "absolute right-[8px]" }));
};
const InputField = React.forwardRef(({ handleChange, handleKeyPress, styledInputClass = 'styled-input', showBorderOnHover, inputClass, bgColorClass, disabled, readOnly, inputError, cancelIcon, htmlFor, label, className = '', type, search, positionSearch = 'absolute left-8 top-[50%] -translate-y-1/2 transform', inputClassFooter = '', password, value, defaultValue, dataCy, autoFocus, onKeyDown, onBlur, onClick, autoComplete, min, maxLength, onFocus, useAutoGrowInput, onMouseDown, onMouseUp, calendar, cancelChanges, placeholder }, ref) => {
    const [offsetWidth, setOffSetWidth] = useState(0);
    const spanRef = useRef(null);
    const [isShowPasswordValue, setIsShowPasswordValue] = useState(false);
    const { setBothLocale } = useLocale();
    const typeInputField = isShowPasswordValue ? 'text' : 'password';
    const _onChange = (e) => {
        if (!disabled && !readOnly) {
            handleChange?.(e);
        }
    };
    const _onKeyPress = (e) => {
        handleKeyPress && handleKeyPress(e);
    };
    const inputCN = ctl(`
      ${styledInputClass}
      ${showBorderOnHover && 'show-border-on-hover'}
      ${inputClass && inputClass}
      ${bgColorClass ? bgColorClass : 'bg-n-000'}
      ${(disabled || readOnly) &&
        'border-gray cursor-not-allowed border border-solid bg-n-100 text-n-800'}
      ${inputError && 'input-error'}
      ${(cancelIcon || password) && 'pr-[40px]'}
      ${search && 'pl-[38px]'}
    `);
    useEffect(() => {
        setOffSetWidth(spanRef?.current?.offsetWidth ?? 0);
    }, [spanRef?.current?.offsetWidth]);
    return (React.createElement("div", { className: `container-input ${className}` },
        label && (React.createElement("label", { className: "styled-label", htmlFor: htmlFor }, setBothLocale(label))),
        search && (React.createElement(SVGIcon, { size: 24, fillColor: "var(--base-600)", iconName: "icon-search", customClass: positionSearch })),
        React.createElement("div", { className: `flex items-center ${inputClassFooter}` },
            React.createElement("input", { ref: ref, className: inputCN, name: htmlFor, onChange: _onChange, onKeyUp: _onKeyPress, id: htmlFor, type: password ? typeInputField : type, value: value, defaultValue: defaultValue, placeholder: setBothLocale(placeholder), "data-cy": dataCy, disabled: disabled, readOnly: readOnly, autoFocus: autoFocus, onKeyDown: onKeyDown, onBlur: onBlur, onClick: onClick, autoComplete: autoComplete, min: min, maxLength: maxLength, onFocus: onFocus, style: {
                    width: useAutoGrowInput ? `${offsetWidth + 8}px` : '100%'
                }, onMouseDown: onMouseDown, onMouseUp: onMouseUp }),
            useAutoGrowInput && (React.createElement("span", { ref: spanRef, className: `invisible ${inputCN} h-0 w-fit border-y-0 py-0` }, value)),
            password && (React.createElement(PasswordIcon, { isShowPasswordValue: isShowPasswordValue, onClick: () => setIsShowPasswordValue(!isShowPasswordValue) })),
            calendar && React.createElement(CalendarIcon, { disabled: disabled || readOnly }),
            cancelIcon && cancelChanges && (React.createElement(SVGIcon, { iconName: "icon-cancel", fillColor: "var(--n-600)", onClick: () => cancelChanges(), size: 24, disabled: disabled, customClass: "absolute right-[8px]" })))));
});
InputField.displayName = 'InputField';
export default InputField;
